import React from 'react';
import styled from "styled-components"
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Link from '@material-ui/core/Link';

const StyledAppBar = styled(AppBar)`
 
`;

const StyledToolbar = styled(Toolbar)`
  
`;

const Content = styled.div`
  padding-top:calc(${props => props.theme.gutter.sp} );
  @media screen and (min-width: ${props => props.theme.breakpoints.values.sm}px){
    max-width:calc(100% - ${props => props.theme.drawerWidth});
    padding-top:calc(${props => props.theme.gutter.pc} );
  }
`

const BarContents = styled(Toolbar)`
  display:flex;
  justify-content: space-between;
  width:100%;
  padding:0;
  @media screen and (min-width: ${props => props.theme.breakpoints.values.sm}px){
    width:1000px;
    margin:0 auto;
  }
`;

const CtaContent = styled.div`
  position:fixed;
  display:flex;
  align-items: center;
  justify-content: center;
  bottom:0;
  left:0;
  height:${props => props.theme.gutter.sp};
  width:100%;
  background:white;
  padding-bottom:env(safe-area-inset-bottom);
  @media screen and (min-width: ${props => props.theme.breakpoints.values.sm}px){
    position:relative;
    width:375px;
    height:${props => props.theme.gutter.pc};
  }
`;

const Logo = styled.img`
    width:auto;
    height:calc(${props => props.theme.gutter.sp} - ${props => props.theme.spacing(3)}px);
`;

export const AppFrame = (props) => {
  return(
    <>
        <StyledAppBar color="inherit">
            <StyledToolbar>
                <BarContents>
                    <Link href="/"><Logo src={props.logoUrl}/></Link>
                    {props.cta?
                    <CtaContent>
                      {props.cta}
                    </CtaContent>
                    :null}
                </BarContents>
            </StyledToolbar>
        </StyledAppBar>
        <Content>
            {props.children}
        </Content>
    </>
  );
}